import './styles.css';

export const Footer = () => {
    return (
        <footer className="footer">
            <h3>Desenvolvido pelo Setor de TI da Prefeitura Municipal de Borrazópolis-PR.</h3>
            <p>Todos os direitos reservados.</p>
        </footer>
    );
}